<template lang="html">
	<div class="home-golf-container container-fluid">
		<slot name="title"></slot>
		<div class="row d-sm-none">
			<div class="col golf-select" slot="select">
				<select class="form-control custom-select" v-on:change="change_golf" v-model="golfSelected">
					<option v-for="option in selectOptions" v-bind:value="option.value">
						{{ option.text }}
					</option>
				</select>
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>

export default {

	props: {

		golfs: {
			required: true
		},

	},

	data() {
		return {
			golfSelected: 'golf1',
			selectOptions: []
		}
	},

	mounted() {
		let options = [];
		this.golfs.forEach(function(item){
			var div = document.createElement('div');
			div.innerHTML = item.name;
			var text = div.textContent || div.innerText || '';
			options.push({ value: item.id, text: text })
		});
		this.selectOptions = options
	},

	methods: {

		change_golf: function() {
			for (let el of document.querySelectorAll('.home-golf-col-card')) {
				el.classList.add("d-none")
				el.classList.add("d-sm-block")
			}
			document.getElementById(this.golfSelected).classList.remove("d-none")
		},

	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GolfComponent.vue